import React, { useEffect } from 'react';
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormHelperText,
  Radio,
} from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { get } from 'lodash';

import CustomPanel from '../../../../common/CustomPanel';

const toRadioValue = (value) => {
  if (value === true) return 'true';
  if (value === false) return 'false';
  return '';
};

/**
 * Covid19 Questions available temporarily.
 * @param fieldName the name of the field on the objet schema.
 * @param hasCovid this function allow to added a new medical condition on MainInsured or Dependent.
 * @param dependantIndex only passed for Dependent component indicate the position of the dependant
 * on the array.
 * @param hasResultPositive when the first covid question is true so the second question is showed
 * for this case is necessary pass explicitly the value and not wait the watch value of the first
 * question. Only passed on EditMode.
 * */
export default function Covid19Questions({
  fieldName,
  hasCovid,
  dependantIndex = undefined,
  hasResultPositive = undefined,
}) {
  const { setValue, formState: { errors }, watch, control, clearErrors } = useFormContext();
  const testPerformedValue = watch(`${fieldName}.questionCovid19TestPerformed`);

  useEffect(() => {
    if (typeof hasResultPositive === 'boolean') {
      setValue(`${fieldName}.questionCovid19ResultPositive`, hasResultPositive);
    }
  }, [hasResultPositive, fieldName, setValue]);

  return (
    <CustomPanel withoutTitle border>
      <Grid item>
        <Controller
          name={`${fieldName}.questionCovid19TestPerformed`}
          control={control}
          render={({ field }) => (
            <FormControl
              component="fieldset"
              error={get(errors, fieldName)?.hasOwnProperty('questionCovid19TestPerformed')}
            >
              <FormLabel component="p">
                Se ha realizado alguna prueba relacionada a COVID19?
                (Prueba PCR, Prueba Rápida , Prueba Cuantitativa y Cualitativa y/o cualquier otra).
              </FormLabel>
              <RadioGroup
                row
                aria-label="test performed"
                name="covid19TestPerformed"
                value={toRadioValue(field.value)}
                onChange={(event) => {
                  const boolValue = JSON.parse(event.target.value);
                  field.onChange(boolValue);
                  clearErrors(`${fieldName}.questionCovid19TestPerformed`);

                  if (event.target.value === 'false') {
                    setValue(`${fieldName}.questionCovid19ResultPositive`, undefined);
                    hasCovid(false, dependantIndex);
                  }
                }}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="Si"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
              <FormHelperText>
                {get(errors, fieldName)?.questionCovid19TestPerformed?.message}
              </FormHelperText>
            </FormControl>
          )}
        />
      </Grid>
      {testPerformedValue === true && (
        <Grid item>
          <Controller
            name={`${fieldName}.questionCovid19ResultPositive`}
            control={control}
            render={({ field }) => (
              <FormControl
                component="fieldset"
                error={get(errors, fieldName)?.hasOwnProperty('questionCovid19ResultPositive')}
              >
                <FormLabel component="p">
                  El resultado de esta prueba fue:
                </FormLabel>
                <RadioGroup
                  row
                  aria-label="test result"
                  name="covid19ResultPositive"
                  value={toRadioValue(field.value)}
                  onChange={(event) => {
                    const boolValue = JSON.parse(event.target.value);
                    field.onChange(boolValue);
                    clearErrors(`${fieldName}.questionCovid19ResultPositive`);
                    hasCovid(event.target.value === 'true', dependantIndex);
                  }}
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Positivo"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="Negativo"
                  />
                </RadioGroup>
                <FormHelperText>
                  {get(errors, fieldName)?.questionCovid19ResultPositive?.message}
                </FormHelperText>
              </FormControl>
            )}
          />
        </Grid>
      )}
    </CustomPanel>
  );
}

Covid19Questions.propTypes = {
  fieldName: PropTypes.string.isRequired,
  hasCovid: PropTypes.func.isRequired,
  dependantIndex: PropTypes.number,
  hasResultPositive: PropTypes.bool,
};
